<ng-container>
  <a
    mat-raised-button
    class="mx-image-upload mini"
    (click)="mxFileInput.click()"
    [disabled]="isFlightLogComplete$ || isMxImageProcessing$ | async"
    ><span *ngIf="mxOperation.method != 'upload'">{{
      mxImageUploadDisplayName$ | async | uppercase
    }}</span
    ><mat-progress-bar
      *ngIf="isMxImageUploading$ | async"
      mode="determinate"
      [value]="mxImageProgress$ | async"
    ></mat-progress-bar>
    <input
      #mxFileInput
      type="file"
      hidden
      name="img"
      accept="image/*"
      (change)="uploadMaintenanceImage($event)"
      [disabled]="isFlightLogComplete$ || isMxImageProcessing$ | async"
  /></a>
  <a
    mat-raised-button
    class="mx-image-delete mini"
    *ngIf="mxImageName$ | async"
    (click)="deleteMaintenanceImage()"
    [disabled]="isFlightLogComplete$ || isMxImageProcessing$ | async"
    ><span *ngIf="mxOperation.method != 'remove'">{{ 'Delete' | uppercase }}</span
    ><mat-progress-bar *ngIf="isMxImageRemoving$ | async" mode="indeterminate"></mat-progress-bar
  ></a>
  <a
    mat-button
    class="mx-image-name"
    *ngIf="mxImageName$ | async"
    (click)="getMaintenanceImage()"
    [disabled]="isMxImageProcessing$ | async"
    ><span *ngIf="mxOperation.method != 'retrieve'">{{ mxImageName$ | async }}</span>
    <mat-progress-bar *ngIf="isMxImageRetrieving$ | async" mode="indeterminate"></mat-progress-bar
  ></a>
  <a
    mat-raised-button
    class="mx-image-cancel mini"
    *ngIf="isMxImageProcessing$ | async"
    (click)="cancelMaintenanceImageProcess()"
    [disabled]="isFlightLogComplete$ || !isMxImageProcessing$ | async"
    ><span>{{ 'Cancel' | uppercase }}</span></a
  >
</ng-container>
